import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import statisticsImg from '../../../assets/images/statistics.svg';
import addProjectImg from '../../../assets/images/add-a-project.png';
import threeProposalsImg from '../../../assets/images/three-proposals.png';
import fireworksImg from '../../../assets/images/selected-fireworks.png';
import medalImg from '../../../assets/images/medal.svg';
import './HowCloraWorksForEmployers.scss';
var buttonText = function buttonText(page) {
  switch (page) {
    case 1:
      return 'Learn how Clora works';
    case 2:
      return 'Learn what to do first';
    default:
      return null;
  }
};
var HowCloraWorksForEmployers = /*#__PURE__*/function (_Component) {
  function HowCloraWorksForEmployers(props) {
    var _this;
    _classCallCheck(this, HowCloraWorksForEmployers);
    _this = _callSuper(this, HowCloraWorksForEmployers, [props]);
    _this.state = {
      page: 1
    };
    _this.handleNextOrClose = _this.handleNextOrClose.bind(_this);
    _this.renderBody = _this.renderBody.bind(_this);
    return _this;
  }
  _inherits(HowCloraWorksForEmployers, _Component);
  return _createClass(HowCloraWorksForEmployers, [{
    key: "handleNextOrClose",
    value: function handleNextOrClose(page) {
      var handleCloseModal = this.props.handleCloseModal;
      if (page <= 2) {
        this.setState({
          page: page + 1
        });
      } else {
        handleCloseModal();
      }
    }
  }, {
    key: "carouselIndicators",
    value: function carouselIndicators(page) {
      var _this2 = this;
      return /*#__PURE__*/React.createElement("ol", {
        className: "step-indicators"
      }, /*#__PURE__*/React.createElement("li", {
        onClick: function onClick() {
          return _this2.setState({
            page: 1
          });
        },
        className: page === 1 ? 'active' : ''
      }), /*#__PURE__*/React.createElement("li", {
        onClick: function onClick() {
          return _this2.setState({
            page: 2
          });
        },
        className: page === 2 ? 'active' : ''
      }), /*#__PURE__*/React.createElement("li", {
        onClick: function onClick() {
          return _this2.setState({
            page: 3
          });
        },
        className: page === 3 ? 'active' : ''
      }));
    }
  }, {
    key: "renderBody",
    value: function renderBody() {
      var page = this.state.page;
      var _this$props = this.props,
        userFirstName = _this$props.userFirstName,
        showDemo = _this$props.showDemo,
        addProjectPath = _this$props.addProjectPath,
        featuredConsultantsPath = _this$props.featuredConsultantsPath;
      switch (page) {
        case 1:
          return /*#__PURE__*/React.createElement("div", {
            className: "text-center page-1"
          }, /*#__PURE__*/React.createElement("div", {
            className: "text-center"
          }, /*#__PURE__*/React.createElement("h1", {
            className: "hero-header"
          }, userFirstName ? "Welcome to Clora, ".concat(userFirstName, "!") : 'Welcome to Clora')), /*#__PURE__*/React.createElement("p", {
            className: "body-text-1"
          }, "Clora's tech platform is faster, more cost-efficient, and yields higher quality talent than traditional recruitment."), /*#__PURE__*/React.createElement("img", {
            src: statisticsImg,
            className: "img-responsive",
            alt: "statistics"
          }));
        case 2:
          return /*#__PURE__*/React.createElement("div", {
            className: "page-2"
          }, /*#__PURE__*/React.createElement("div", {
            className: "text-center"
          }, /*#__PURE__*/React.createElement("h1", {
            className: "hero-header"
          }, "How does Clora work?")), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
            xs: 12,
            sm: 4
          }, /*#__PURE__*/React.createElement("img", {
            src: addProjectImg,
            className: " mb-3  img-responsive d-none d-sm-block add-projects-img",
            alt: "add projects"
          }), /*#__PURE__*/React.createElement("div", {
            className: "page-2-list-item"
          }, /*#__PURE__*/React.createElement("div", {
            className: "page-2-item-header body-text-1"
          }, "1. Add a project"), /*#__PURE__*/React.createElement("p", {
            className: "body-text-1 ms-3 mt-5"
          }, "Tell us about your need and your account manager will contact you."))), /*#__PURE__*/React.createElement(Col, {
            xs: 12,
            sm: 4
          }, /*#__PURE__*/React.createElement("img", {
            src: threeProposalsImg,
            className: " mb-3  img-responsive d-none d-sm-block three-proposals-img",
            alt: "three proposals"
          }), /*#__PURE__*/React.createElement("div", {
            className: "page-2-list-item"
          }, /*#__PURE__*/React.createElement("div", {
            className: "page-2-item-header body-text-1"
          }, "2. Receive up to 3 proposals"), /*#__PURE__*/React.createElement("p", {
            className: "body-text-1 ms-3 mt-5"
          }, "Clora's industry experts vet high-fit, top-tier candidates from global talent pools."))), /*#__PURE__*/React.createElement(Col, {
            xs: 12,
            sm: 4
          }, /*#__PURE__*/React.createElement("img", {
            src: fireworksImg,
            className: " mb-3  img-responsive d-none d-sm-block fireworks-img",
            alt: "fireworks"
          }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
            className: "page-2-item-header body-text-1"
          }, "3. Select the best fit!"), /*#__PURE__*/React.createElement("p", {
            className: "body-text-1 ms-3 mt-5"
          }, "Interview candidates you like and hire the best one.")))));
        case 3:
          return /*#__PURE__*/React.createElement("div", {
            className: "page-3"
          }, /*#__PURE__*/React.createElement("div", {
            className: "text-center"
          }, /*#__PURE__*/React.createElement("h1", {
            className: "hero-header"
          }, "What can you do next at Clora?")), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
            xs: 12,
            sm: 6
          }, /*#__PURE__*/React.createElement("div", {
            className: "add-project-container"
          }, /*#__PURE__*/React.createElement("a", {
            href: addProjectPath,
            className: "btn btn-primary bigger-button how-clora-works-add-project"
          }, "Add Project"), /*#__PURE__*/React.createElement("h3", {
            className: "mt-4"
          }, "If you know your project needs"), /*#__PURE__*/React.createElement("div", {
            className: "explanation body-text-1"
          }, "Answer a few questions to create your first project and wait for candidates!"))), /*#__PURE__*/React.createElement(Col, {
            xs: 12,
            sm: 6,
            className: "not-sure"
          }, /*#__PURE__*/React.createElement("div", {
            className: "body-text-1 top-consultants-container"
          }, /*#__PURE__*/React.createElement("img", {
            src: medalImg,
            className: "img-responsive medal-img",
            alt: "medal"
          }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("a", {
            href: featuredConsultantsPath,
            className: "how-clora-works-top-consultants",
            role: "button",
            tabIndex: 0
          }, "Browse Top Consultants"), /*#__PURE__*/React.createElement("h3", {
            className: "mt-4"
          }, "If you aren't sure about your need"), /*#__PURE__*/React.createElement("div", {
            className: "explanation body-text-1"
          }, "Browse Clora's top available consultants for mission-critical needs.")))), /*#__PURE__*/React.createElement("div", {
            className: "body-text-2 request-demo-prompt"
          }, "If you want to know more about our services, we'll introduce you to Clora!", /*#__PURE__*/React.createElement("a", {
            onClick: function onClick() {
              return showDemo();
            },
            className: "how-clora-works-request-demo",
            role: "button",
            tabIndex: 0
          }, "Request a demo")));
        default:
          return null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var page = this.state.page;
      return /*#__PURE__*/React.createElement("div", {
        className: "style-guide"
      }, /*#__PURE__*/React.createElement("div", null, this.renderBody()), /*#__PURE__*/React.createElement("div", {
        className: "text-center"
      }, page < 3 && /*#__PURE__*/React.createElement("button", {
        className: "btn btn-primary bigger-button next-page-button how-clora-works-page-".concat(page, "-btn"),
        onClick: function onClick() {
          return _this3.handleNextOrClose(page);
        }
      }, buttonText(page)), this.carouselIndicators(page)));
    }
  }]);
}(Component);
HowCloraWorksForEmployers.propTypes = {
  userFirstName: PropTypes.string,
  handleCloseModal: PropTypes.func.isRequired,
  showDemo: PropTypes.func.isRequired,
  addProjectPath: PropTypes.string.isRequired,
  featuredConsultantsPath: PropTypes.string.isRequired
};
HowCloraWorksForEmployers.defaultProps = {
  userFirstName: null
};
export default HowCloraWorksForEmployers;